import { render, staticRenderFns } from "./imRate.vue?vue&type=template&id=42c029d4"
import script from "./imRate.vue?vue&type=script&lang=js"
export * from "./imRate.vue?vue&type=script&lang=js"
import style0 from "./imRate.vue?vue&type=style&index=0&id=42c029d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports